import { IMaintenanceBlankSchema } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import useMaintenanceBlankSchema from '@/pages/Processes/Maintenance/hooks/useMaintenanceBlankSchema.ts'
import { Fragment } from 'react'
import css from '@/pages/Processes/Maintenance/MaintenanceBlanks/components/MaintenanceBlankSidePage/maintenanceBlankSidePage.module.css'
import SeparateLine from '@/shared/Forms/SeparateLine'
import timeUtils from '@/utils/time.utils.ts'
import FormEditButton from '@/shared/Buttons/FormEditButton'
import FormDeleteButton from '@/shared/Buttons/FormDeleteButton'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import maintenanceApi from '@/pages/Processes/Maintenance/maintenance.api.ts'
import maintenanceEvents from '@/pages/Processes/Maintenance/events/maintenance.events.ts'
import ProtectedContent from '@/services/rights/ProtectedContent'

interface IProps {
  id: IMaintenanceBlankSchema['id']
  onEdit: () => void
  onClose: () => void
}

const ViewMaintenanceBlankSidePageContent = (props: IProps) => {
  const blank = useMaintenanceBlankSchema(props.id)

  const handleDelete = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление бланка ${blank.name}`,
      buttonType: 'primary',
      onConfirm: () =>
        maintenanceApi
          .deleteBlankSchema(props.id)
          .then((r) => r.status === 'success' && maintenanceEvents.schemaDeleted(r.body.id))
          .then(() => props.onClose()),
    })
  }

  const renderBlankFields = () => {
    return blank.fields.map((f, index) => (
      <Fragment key={f.id}>
        <div className="flex-lines gap16">
          <h3 className="text-heading-5">{f.name}</h3>
          <div className={css.maintenanceBlankSidePageGrid}>
            <p className="text-nm text-secondary">Тип данных:</p>
            <p className="text-nm">{f.type}</p>
            <p className="text-nm text-secondary">Содержание работ:</p>
            <p className="text-nm">{f.instruction}</p>
            <p className="text-nm text-secondary">Технические требования:</p>
            <p className="text-nm">{f.requirements}</p>
          </div>
        </div>

        {index < blank.fields.length - 1 && <SeparateLine />}
      </Fragment>
    ))
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h2 className="text-heading-4" style={{ width: '80%' }}>
        Бланк обслуживания "{blank.name}"
      </h2>
      <div style={{ paddingRight: '20px' }}>
        <SeparateLine />
      </div>
      <div className={css.maintenanceBlankSidePageGrid}>
        <p className="text-nm text-secondary">Дата создания:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(blank.createdAt), 'dd MMM yyyy')}</p>
        <p className="text-nm text-secondary">Дата обновления:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(blank.createdAt), 'dd MMM yyyy')}</p>
      </div>
      <div style={{ paddingRight: '20px' }}>
        <SeparateLine />
      </div>
      <div className="flex-lines gap16" style={{ minHeight: 0, overflow: 'auto', paddingRight: '20px' }}>
        {renderBlankFields()}
      </div>

      <div style={{ marginTop: 'auto', paddingRight: '20px' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <ProtectedContent requiredRight="mdm:update_schema">
          <FormEditButton onClick={props.onEdit} />
        </ProtectedContent>
        <ProtectedContent requiredRight="mdm:delete_schema">
          <FormDeleteButton onClick={handleDelete} />
        </ProtectedContent>
      </div>
    </div>
  )
}

export default ViewMaintenanceBlankSidePageContent
